var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmoothie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M385.693,170.653C378.2,102.88,320.751,50.163,250.98,50.163s-127.22,52.716-134.714,120.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.204,170.653l51.369-119.847c5.643-13.184,16.658-23.315,30.263-27.853L426.694,10"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 284.697,
    y1: 220.857,
    x2: 253.41,
    y2: 293.844
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M316.243,281.102c-55.225,0-55.225,20.082-110.451,20.082c-43.363,0-52.68-12.381-81.417-17.699l27.522,192.653 c2.12,14.84,14.829,25.862,29.82,25.862h138.525c14.991,0,27.7-11.023,29.82-25.862l26.182-183.274 C360.65,287.341,347.025,281.102,316.243,281.102z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M115.429,220.857l36.469,255.28c2.12,14.84,14.829,25.862,29.82,25.862h138.525c14.991,0,27.7-11.023,29.82-25.862l36.469-255.28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M391.551,220.857H110.408c-13.864,0-25.102-11.238-25.102-25.102l0,0c0-13.863,11.239-25.102,25.102-25.102h281.143 c13.863,0,25.102,11.238,25.102,25.102l0,0C416.653,209.619,405.414,220.857,391.551,220.857z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothie);
export default __webpack_public_path__ + "static/media/smoothie.9264ad6e189d35592c00c0aebd4d725e.svg";
export { ForwardRef as ReactComponent };